import { ChangeDetectorRef, Inject, Optional, Pipe, PipeTransform } from '@angular/core';
import {
  HashMap,
  MaybeArray,
  TRANSLOCO_LANG,
  TRANSLOCO_SCOPE,
  TranslocoPipe,
  TranslocoScope,
  TranslocoService,
} from '@ngneat/transloco';
import { SYSTEM_LANGUAGES } from '../../../assets/i18n';

@Pipe({
  name: 'localize',
  pure: false,
})
export class LocalizePipe extends TranslocoPipe implements PipeTransform {
  constructor(
    translocoService: TranslocoService,
    @Optional()
    @Inject(TRANSLOCO_SCOPE)
    providerScope: MaybeArray<TranslocoScope> | undefined,
    @Optional()
    @Inject(TRANSLOCO_LANG)
    providerLang: string | undefined,
    cdr: ChangeDetectorRef,
    protected serv: TranslocoService,
  ) {
    super(translocoService, providerScope, providerLang, cdr);
  }

  // По умолчанию при отсутствии в списке доступных языков (грузится на этапе сборки)
  // вовзращется сообщение [lang].message. Мы же проверяем, в случае отсутствия в начальном списке
  // перенаправляем принудительно, тк по умолчнию он будет вести на ссылку к русскому языку
  transform(key?: string | null, params?: HashMap, inlineLang?: string) {
    if ((this.serv.getAvailableLangs() as string[]).includes(this.serv.getActiveLang())) {
      const locText = super.transform(key, params, inlineLang);
      if (locText && !locText.includes(key)) return locText;
    }
    return this.extractKeyValue(SYSTEM_LANGUAGES.RU, key);
  }

  private extractKeyValue(object: any, key?: string): any | string {
    if (typeof object === 'string' || !key) return object;
    const dotPosition = key.indexOf('.');
    const field = key.substring(0, dotPosition !== -1 ? dotPosition : key.length);
    if (!object[field]) return field;
    const nextField = key.substring(dotPosition + 1);
    return this.extractKeyValue(object[field], nextField);
  }
}
